import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaFileUploadListItem from './VaFileUploadListItem.vue'

export default withConfigTransport(VaFileUploadListItem)
